import Dialog, {
  DialogHeader,
  DialogHeading,
} from '@raydiant/raydial/components/Dialog';
import Modal from '@raydiant/raydial/components/Modal';
import Text from '@raydiant/raydial/components/Text';
import UpgradePlanImg from './upgrade-plan.svg';
import Button from '@raydiant/raydial/components/Button';

interface UpgradePlanDialogProps {
  isOpen: boolean;
  onSubscribe: () => void;
  onClose: () => void;
}

const UpgradePlanDialog = ({
  isOpen,
  onSubscribe,
  onClose,
}: UpgradePlanDialogProps) => {
  return (
    <Modal isOpen={isOpen} className="overflow-auto">
      <Dialog className="grid relative" showCloseButton onClose={onClose}>
        <DialogHeader>
          <DialogHeading>Unlock all the power of Displai!</DialogHeading>
        </DialogHeader>
        <div className="flex flex-col items-center px-4">
          <img
            src={UpgradePlanImg}
            alt="free trial expired"
            className="w-[274px] aspect-[1.028] mb-8"
          />
          <Text className="text-center text-2xl md:text-3xl font-semibold">
            Looking to add even more devices? Upgrade your plan!
          </Text>
          <Text className="mt-6 md:mt-10">
            Upgrade your plan to the Pro or Enterprise level and add even more
            devices! The Enterprise level features unlimited devices and special
            pricing.
          </Text>
        </div>
        <footer className="flex flex-wrap gap-6 pb-4 px-4 mt-8">
          <Button
            size="large"
            variant="primary"
            className="grow"
            onPress={onSubscribe}
          >
            Upgrade Now
          </Button>
        </footer>
      </Dialog>
    </Modal>
  );
};

export default UpgradePlanDialog;
